import { getSqrtRatioAtTick, getTickAtSqrtRatio } from "@/domains/manual-cl-core"

const MAX_TICK_DRIFT = 1

export function resolveCoherentSqrtPriceX96({
  currentSqrtPriceX96,
  currentTick,
}: {
  currentSqrtPriceX96: bigint | undefined
  currentTick: number | undefined
}): bigint | undefined {
  if (currentTick === undefined) return currentSqrtPriceX96

  if (currentSqrtPriceX96 !== undefined) {
    try {
      const tickFromSqrt = getTickAtSqrtRatio(currentSqrtPriceX96)
      if (Math.abs(tickFromSqrt - currentTick) <= MAX_TICK_DRIFT) {
        return currentSqrtPriceX96
      }
    } catch {
      // Fall through to tick-derived sqrt when the indexed sqrt is unusable.
    }
  }

  try {
    return getSqrtRatioAtTick(currentTick)
  } catch {
    return undefined
  }
}
